import { SceneSprite } from "GameObjects/StoryGame/SceneSprite";
import { Expo, TimelineLite, TimelineMax, TweenLite } from "gsap";
import * as HLF from "html-living-framework";
import { Application } from "Singletons/Application";
import { AbstractStoryState } from "States/AbstractStoryState";
import { list } from "Utils/Reflection";

import {ch5_p16} from "../../../layouts/ch5_p16/ch5_p16";

export class Chapter5Page16 extends AbstractStoryState implements ReturnType<typeof ch5_p16> {

    readonly bg = this.addChild(new SceneSprite());
    readonly balloons = [this.addChild(new SceneSprite()), this.addChild(new SceneSprite())];
    readonly holly = [this.addChild(new SceneSprite()), this.addChild(new SceneSprite())];
    readonly tyler = [this.addChild(new SceneSprite()), this.addChild(new SceneSprite())];
    readonly rainoverlay = this.addChild(new SceneSprite());
    readonly rain = this.addChild(new SceneSprite());

	readonly frameLeft = this.addChild(SceneSprite.withPrefix("ch5_p16/"));
	readonly frameRight = this.addChild(SceneSprite.withPrefix("ch5_p16/"));
	readonly linesLeft = this.addChild(SceneSprite.withPrefix("ch5_p16/"));
	readonly linesRight = this.addChild(SceneSprite.withPrefix("ch5_p16/"));

    dontScaleUp = true;

    public init(pSize: PIXI.Point, pData: any) {
		// exported layouts from Animate CC
        ch5_p16.call(this);

        this.balloons[1].visible = false;
        this.holly[1].visible = false;
        this.tyler[1].visible = false;
        this.rainoverlay.visible = false;
        this.rain.visible = false;

		// super.init calls onResize
		super.init(pSize, pData);
	}

	public update(pDeltaTime: number) {
		super.update(pDeltaTime);
	}

	public animateIn(pOnComplete: ()=>void) {
        super.animateIn(pOnComplete);
        const intro = HLF.Application.instance.audio.createAudioTrack("HH_Ch5_Holly_Tyler_InRain_Intro_P16", HLF.AudioCategory.BGM);
        const mainLoop = HLF.Application.instance.audio.createAudioTrack("HH_Ch5_Holly_Tyler_InRain_LoopC_P16-17", HLF.AudioCategory.BGM);
        mainLoop.setLooped(true);
        intro.once(HLF.HowlerUtils.Events.END, ()=>{
            mainLoop.play();
			intro.unloadSource();
        });
        intro.play();
    }

    public animateOut(pOnComplete: ()=>void) {
        super.animateOut(pOnComplete);
    }

    public onAnimateInComplete() {
        new TimelineLite()
            .call(()=>{
                this.balloons[0].FadeOut();
                this.holly[0].FadeOut();
                this.tyler[0].FadeOut();

                this.holly[1].FadeIn();
                this.tyler[1].FadeIn();
                this.rainoverlay.FadeIn();
                this.rain.FadeIn();
            }, undefined, undefined, "+=1.5")
            .call(()=>{
                super.onAnimateInComplete();
            }, undefined, undefined, "+=1.5")
            .call(()=>{
                this.gotoNextState({transition: "fade"});
            }, undefined, undefined, "+=1.5");
    }
}